import { render, staticRenderFns } from "./Order_mobile.vue?vue&type=template&id=0b4a0781&scoped=true&"
import script from "./Order_mobile.vue?vue&type=script&lang=js&"
export * from "./Order_mobile.vue?vue&type=script&lang=js&"
import style0 from "./Order_mobile.vue?vue&type=style&index=0&id=0b4a0781&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4a0781",
  null
  
)

export default component.exports